import React, { useState } from "react";
import "./User.css";
import { Container } from "react-bootstrap";
import { GoChevronDown } from "react-icons/go";
import Footer from '../Footer/Footer'
import Navbaruser from "../Navbar/Navbaruser";
import Sidebaruser from "../Sidebar/SIdebaruser";
import Search from "../Sidebar/Search-input";

const User = () => {
 const [isActive, setActive] = useState(false);
 const toggleClass = () => {
   setActive(!isActive);
 }
  return (
    <>
      <div className="App">
        <div className="side-bar ">
          <Sidebaruser handleToggle={toggleClass} isActive={isActive}/>
        </div>
        <div className="main w-100">
          <Navbaruser isActive={isActive}/>
          <Container>
            <div className="head-user">
             
              <div className="user-main">
               <div className="user-form">
                <form action="">
                <div className="name-field">
                   <div className="f-name">
                     <label htmlFor="">Name</label>
                     <input type="text" />
                   </div>
                   <div className="f-name">
                     <label htmlFor="">Email</label>
                     <input type="text" />
                   </div>
                 </div>
                 <div className="name-field ">
                   <div className="f-name">
                     <label htmlFor="">Phone</label>
                     <input type="text" />
                   </div>
                   <div className="f-name">
                     <label htmlFor="">City</label>
                     <input type="text" />
                   </div>
                 </div>
                 <div className="name-field">
                   <div className="f-name">
                     <label htmlFor="">Role</label>
                     <Search/>
                   </div>
                  
                 </div>
               
                 <div className="login-btn submit-btn"><button type='submit'><span>Submit</span></button></div>
                </form>
                </div>
              </div>
            </div>
           
          </Container>
          <Footer />
        </div>
        
      </div>
      
    </>
  );
};

export default User;
